const removeNewlines = (input: string | null) => {
  if (!input) {
    return null;
  }

  return input.replace(/\n/g, '');
};

export default removeNewlines;
